import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { Loader } from 'core/components';

function PickingBatchInfoTemplate({ pickingBatchInfoViewStore: { data, loading }, t }) {
	if (loading) return <Loader />;

	if (!data || !data.infos || data.infos.length === 0) {
		return (
			<section>
				<div className="ReactModal__header">
					<h2 className="spc--bottom--sml">
						{isSuccess ? (
							<i className="type--color--success fa fa-check-circle spc--right--sml" />
						) : (
							<i className="type--color--error fa fa-times-circle spc--right--sml" />
						)}
						{t('PICKINGBATCHINFOVIEW.PICKINGBATCHINFO', { pickingBatchId: data.pickingBatchId })}
					</h2>
					<p>{t('PICKINGBATCHINFOVIEW.PICKINGBATCHINFONOINFOAVAILABLE')}</p>
				</div>
			</section>
		);
	}

	var infos = data.infos;
	var firstInfo = infos[0];
	var isSuccess = firstInfo && firstInfo.success === true;

	return (
		<section>
			<div className="ReactModal__header">
				<h2 className="spc--bottom--sml">
					{isSuccess ? (
						<i className="type--color--success fa fa-check-circle spc--right--sml" />
					) : (
						<i className="type--color--error fa fa-times-circle spc--right--sml" />
					)}
					{t('PICKINGBATCHINFOVIEW.PICKINGBATCHINFO', { pickingBatchId: data.pickingBatchId })}
				</h2>
			</div>

			<div className="ReactModal__body">
				<InfoList items={infos} isSuccess={isSuccess} dateCreated={data.infos[0].dateCreated} t={t} />
			</div>

			<div className="ReactModal__footer"></div>
		</section>
	);
}

function InfoList({ items, isSuccess, dateCreated, t }) {
	if (!items || items.length === 0) return <p> {t('PICKINGBATCHINFOVIEW.PICKINGBATCHINFONOERRORSFOUND')} </p>;

	var errorEntries = filterEmptyErrors(items);

	return (
		<div className="pickingbatch-info__list pickingbatch-info" style={{ padding: '1rem 0' }}>
			{isSuccess && (
				<div className="pickingbatch-info__entry">
					<h4 className="pickingbatch-info__date">{new Date(dateCreated).toLocaleString()}</h4>
					<ul className="pickingbatch-info__errors pickingbatch-info__list_no_bulletpoints">
						<li className="pickingbatch-info__success type--color--success pickingbatch-info__list_element">
							<i className="type--color--success fa fa-check-circle spc--right--nano" />
							{t('PICKINGBATCHINFOVIEW.PICKINGBATCHINFOSUCCESSMESSAGE')}
						</li>
					</ul>
				</div>
			)}

			{errorEntries.map(function(entry, idx) {
				return (
					<div key={entry.id || idx} className="pickingbatch-info__entry">
						<h4 className="pickingbatch-info__date">{new Date(entry.dateCreated).toLocaleString()}</h4>
						<ul className="pickingbatch-info__errors pickingbatch-info__list_no_bulletpoints">
							{entry.errors.map(function(err, i) {
								return (
									<li key={i} className="pickingbatch-info__error pickingbatch-info__list_element">
										<i className="type--color--error fa fa-times-circle spc--right--nano" /> {err}
									</li>
								);
							})}
							{entry.warnings &&
								entry.warnings.length > 0 &&
								entry.warnings.map(function(warning, i) {
									return (
										<li key={i} className="pickingbatch-info__warning pickingbatch-info__list_element">
											<i className="type--color--warning-light fa fa-exclamation-circle spc--right--nano" /> {warning}
										</li>
									);
								})}
						</ul>
					</div>
				);
			})}
		</div>
	);
}

function filterEmptyErrors(items) {
	var errorEntries = [];
	for (var i = 0; i < items.length; i++) {
		var entry = items[i];
		if (entry.errors && entry.errors.length > 0) {
			errorEntries.push(entry);
		}
	}
	return errorEntries;
}

export default defaultTemplate(PickingBatchInfoTemplate);
